
import React from 'react';
import { Ad } from '../types';
import { ExternalLink, Info, MoreHorizontal } from 'lucide-react';
import { Logo } from './Logo';

interface SponsoredAdProps {
  ad: Ad;
}

export const SponsoredAd: React.FC<SponsoredAdProps> = ({ ad }) => {
  return (
    <div className="bg-white dark:bg-black border-y md:border border-gray-100 dark:border-zinc-800 md:rounded-lg overflow-hidden mb-8 shadow-sm">
      {/* Ad Header */}
      <div className="flex items-center justify-between p-3">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-blue-500 p-[1px] flex items-center justify-center">
            <Logo size={20} className="text-white" />
          </div>
          <div>
            <div className="flex items-center gap-1">
              <p className="text-xs font-black dark:text-white leading-none">Findily Sponsored</p>
              <Info className="w-2.5 h-2.5 text-gray-400" />
            </div>
            <p className="text-[10px] text-blue-500 font-black uppercase tracking-widest leading-tight mt-0.5">Partner Promotion</p>
          </div>
        </div>
        <button className="p-1 active:scale-90 transition-transform"><MoreHorizontal className="w-5 h-5 text-gray-400 dark:text-zinc-600" /></button>
      </div>

      {/* Ad Image */}
      <div className="aspect-square bg-gray-100 dark:bg-zinc-900 overflow-hidden relative group">
        <img 
          src={ad.image_url} 
          alt={ad.title} 
          className="w-full h-full object-cover" 
          loading="lazy"
        />
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors pointer-events-none" />
        
        {/* CTA Overlay */}
        <a 
          href={ad.link_url} 
          target="_blank" 
          rel="noopener noreferrer"
          className="absolute bottom-4 left-4 right-4 bg-blue-600 text-white py-3 rounded-xl flex items-center justify-center gap-2 text-[10px] font-black uppercase tracking-widest shadow-2xl active:scale-95 transition-all"
        >
          Learn More <ExternalLink className="w-3 h-3" />
        </a>
      </div>

      {/* Ad Body */}
      <div className="p-4">
        <div className="space-y-1">
          <div className="text-sm dark:text-gray-200">
            <span className="font-black mr-2 text-gray-900 dark:text-white">findily_ads</span>
            <span className="font-black text-gray-800 dark:text-zinc-300">{ad.title}</span>
          </div>
          <p className="text-xs text-gray-500 dark:text-zinc-500 leading-relaxed font-medium">
            {ad.description}
          </p>
        </div>
      </div>
    </div>
  );
};
